





















import { Vue, Component, Prop } from 'vue-property-decorator'
import { mapMutations } from 'vuex'

@Component({
    methods: {
        ...mapMutations('dossieracademique', ['UPDATE_DATAS_DERNIER_DIPLOME', 'UPDATE_DATAS_DERNIER_DIPLOME_AUTRE'])
    }
})
export default class SelectDiplome extends Vue {
    @Prop() selectedValue?: string
    @Prop() other?: string
    @Prop() readOnly?: boolean

    options = [
        { id: 'Doctorat', value: 'Doctorat' },
        { id: 'Agrégation', value: 'Agrégation' },
        { id: 'Master', value: 'Master' },
        { id: 'Licence', value: 'Licence' },
        { id: 'Diplôme d\'ingénieur', value: 'Diplôme d\'ingénieur' },
        { id: 'Autre', value: 'Autre' }
    ]

    // Event change sur le select
    updateDatasPro (e: Event) {
        if (e.target !== null) {
            const target = e.target as HTMLTextAreaElement
            if (target.name === 'diplome') {
                this.$store.commit('dossieracademique/UPDATE_DATAS_DERNIER_DIPLOME', target.value)
            }
            if (target.name === 'diplome_other') {
                this.$store.commit('dossieracademique/UPDATE_DATAS_DERNIER_DIPLOME_AUTRE', target.value)
            }
        }
    }
}
